import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { CdnImg } from '@webplatform/cdn-image';
import { useBreakpoint, useSwiperElement } from '~/composables';
import { handleImageSrc, handleImageAlt } from '~/helpers';

interface Props {
  data?: { id?: string; items: any };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SoftwareCategoryReviewsSlider',
  props: {
    data: { default: () => ({ items: [] }) }
  },
  setup(__props: any) {

const props = __props as { data: { id?: string; items: any } };



const { isBiggerThanBreakpoint: isDesktop } = useBreakpoint('lg');

const swiperOptions = {
  navigation: {
    prevEl: '.nav-prev',
    nextEl: '.nav-next',
  },
  loop: true,
  slidesPerView: 1,
  spaceBetween: 16,
  observer: true,
};

const swiperEl = useSwiperElement(swiperOptions);

const showNav = computed(
  () => isDesktop.value && props.data?.items?.length > 1,
);

return { __sfc: true,props, isDesktop, swiperOptions, swiperEl, showNav, CdnImg, handleImageSrc, handleImageAlt }
}

})